import React, { useState, useEffect } from 'react';
import {Container, Grid, Button, IconButton} from "@mui/material";
import "./FinalPrice.css";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalAirportRoundedIcon from '@mui/icons-material/LocalAirportRounded';
import LockIcon from '@mui/icons-material/Lock';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CustomModal from "../components/CustomModal/CustomModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSection } from '../../context/SectionContext';
import AlertResponsive from '../../images/alerta.png'
import { Link } from 'react-router-dom';
import useRedirectIframe from "../../hooks/useRedirectIframe";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { URLS } from '../../context/urls'
import { FINAL_PRICE_TEXTS } from './finalPriceTexts'; // Import the texts

function NumberFormatter(number) {
    return number.toLocaleString()
}

function FinalPrice({ datos }) {
    const { changeSection } = useSection();

    useRedirectIframe(URLS.REDIRECT_IFRAME);

    useEffect(() => {
        console.log("Datos recibidos en FinalPrice:", datos);
    }, [datos]);

    const [recuadroVisible, setRecuadroVisible] = useState(false);
    const today = new Date();
    const dateString = today.toLocaleDateString('es-ES');
    const logistic = NumberFormatter(datos.logist);
    const dolar = NumberFormatter(datos.dolar_today);
    const product_price = NumberFormatter(datos.cop_product);

    let international_ship, insurance, final_price, tax, insurance_cal, servicio;

    if (datos.service === 'shopper') {
        servicio = FINAL_PRICE_TEXTS.SERVICE_TYPES.SHOPPER;
        international_ship = NumberFormatter(datos.cop_ship_shopper + datos.cop_tax_shopper);
        insurance = NumberFormatter(datos.cop_insurance_shopper);
        tax = datos.cop_tax_shopper;
        final_price = datos.cop_ship_shopper + datos.cop_product;
        insurance_cal = datos.cop_insurance_shopper;
    } else if (datos.service === 'locker') {
        servicio = FINAL_PRICE_TEXTS.SERVICE_TYPES.LOCKER;
        international_ship = NumberFormatter(datos.cop_ship_locker + datos.cop_tax_locker);
        insurance = NumberFormatter(datos.cop_insurance_locker);
        tax = datos.cop_tax_locker;
        final_price = datos.cop_ship_locker;
        insurance_cal = datos.cop_insurance_locker;
    }

    if (datos.insurance){
        final_price = NumberFormatter(final_price + tax + datos.logist + insurance_cal)
    }
    else{
        final_price = NumberFormatter(final_price + tax + datos.logist)
    }

    const handleClick = () => {
        setRecuadroVisible(!recuadroVisible);
    };

    const handleClose = () => {
        setRecuadroVisible(false);
    };


    useEffect(() => {
        document.body.classList.toggle('recuadro-abierto', recuadroVisible);
    }, [recuadroVisible]);

    return (
        <>
            <IconButton
                aria-label="close"
                onClick={() => changeSection('calculator')}
                style={{ position: 'absolute', left: '1vw', top: '0.2vw'}}
            >
                <ArrowBackIcon sx={{
                            color: "#5452ff",
                            fontSize: { xs: '5vw', sm: '1vw', md: '1vw', lg: '1.5vw', xl: '2vw' },
                            p: "1px"
                        }}/> <span className='boton-regresar' style={{paddingLeft: '0.2vw', fontFamily:'Viga'}}>{FINAL_PRICE_TEXTS.BACK_BUTTON}</span>
            </IconButton>
            <Container maxWidth="xl">
            <div className='modalidad-container'>
                <p className='modalidad-text'>{FINAL_PRICE_TEXTS.MODALITY_TEXT}</p>
                    <div className='servicio-container'>
                        <span className='servicio-text'>{servicio}</span>
                    </div>
            </div>
                
                <div className='content-title-text'>
                    <span className='title-text'>{FINAL_PRICE_TEXTS.TITLE.MAIN}</span>
                    <span className='title-text2'>{FINAL_PRICE_TEXTS.TITLE.SUB}</span>
                </div>
                <div className='total'>
                    <span>${final_price}*</span>
                </div>
                        <div className='undertext-new'>
                <span className='paragraph1'>{FINAL_PRICE_TEXTS.PRICE_INFO.FINAL_VALUE}</span>
                </div>
                <div className='under-text'>
                    {FINAL_PRICE_TEXTS.PRICE_INFO.VALID_FOR} <AccessTimeIcon
                        sx={{
                            color: "#5452ff",
                            fontSize: { xs: '5vw', sm: '1vw', md: '1.2vw', lg: '1.6vw', xl: '1.6vw' },
                            p: "1px"
                        }} /> ───
                </div>
                       
                <img className="alert-responsive" src={AlertResponsive} alt=""></img>
                    <div className='text-container-p'>
                    
                    <span className='parrafo-sorpresa'>{FINAL_PRICE_TEXTS.PRICE_INFO.NO_SURPRISES} <span className='paragraph-color'>{FINAL_PRICE_TEXTS.PRICE_INFO.INCLUDES_ALL}</span> {FINAL_PRICE_TEXTS.PRICE_INFO.FROM_MIAMI}{' '}
                        <span onClick={handleClick} className='textoClickeable'>
                            {FINAL_PRICE_TEXTS.PRICE_INFO.CLICK_HERE}
                        </span>
                    </span>
                </div>
                            
                <Grid container spacing={0} justifyContent="center">
                    <Grid item>
                        {/* Utiliza un div para alinear el icono con el texto en el botón */}
                        <div className='boton2-container'>
                        <Link to="/crear-casillero">
                            <Button id="boton2" variant="contained" color="primary">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {FINAL_PRICE_TEXTS.BUTTONS.CREATE_LOCKER}     <LocalShippingIcon style={{ marginLeft: '8px' }} sx={{
                            fontSize: { xs: '3vw', sm: '1.5vw', md: '1.5vw', lg: '2vw', xl: '2.2vw' },
                            p: "1px"
                        }} />
                                </div>
                            </Button>
                            </Link>
                        </div>
                    </Grid>
                </Grid>

                <div className='final-text'>
                    <span>{FINAL_PRICE_TEXTS.ACCOUNT_INFO.HAVE_ACCOUNT}</span><a href="/inicio-sesion">{FINAL_PRICE_TEXTS.ACCOUNT_INFO.LOGIN}</a>
                </div>
                <div className='disclaimer'>
                    {FINAL_PRICE_TEXTS.DISCLAIMER}
                </div>
            </Container>

            {recuadroVisible && (
                <>
                    {/* Reemplaza el Backdrop y Dialog con el CustomModal */}
                    <CustomModal
                        open={recuadroVisible}
                        onClose={handleClose}
                        title={
                            <>
                                <span className="tituloRecuadro">{FINAL_PRICE_TEXTS.MODAL.TITLE}</span>
                            </>
                        }
                        content={
                            <>
                                <p className="textoUsd">{FINAL_PRICE_TEXTS.MODAL.TRM_TEXT} ${dolar} {FINAL_PRICE_TEXTS.MODAL.COP} {dateString}</p>
                                <div className="subtitle">
                                    <h2 className="subtitulo">
                                        <ShoppingCartIcon style={{ color: "#5452ff", fontSize: {xs: "1.6vw", sm: "3vw"} }} /> {FINAL_PRICE_TEXTS.MODAL.SECTIONS.PRODUCT_PRICE}
                                    </h2>
                                    <p className="contenido">${product_price} {FINAL_PRICE_TEXTS.MODAL.COP} </p>
                                </div>
                                <div className="subtitle">
                                    <h2 className="subtitulo">
                                        <LocalAirportRoundedIcon style={{ color: "#5452ff", fontSize: {xs: "1.6vw", sm: "3vw"} }} /> {FINAL_PRICE_TEXTS.MODAL.SECTIONS.INTERNATIONAL_SHIPPING}
                                    </h2>
                                    <p className="contenido">${international_ship} {FINAL_PRICE_TEXTS.MODAL.COP} </p>
                                </div>
                                <div className="subtitle">
                                    <h2 className="subtitulo">
                                        <WarehouseIcon style={{ color: "#5452ff", fontSize: {xs: "1.6vw", sm: "3vw"} }} /> {FINAL_PRICE_TEXTS.MODAL.SECTIONS.LOGISTIC_EXPENSES}
                                    </h2>
                                    <p className="contenido">${logistic} {FINAL_PRICE_TEXTS.MODAL.COP}</p>
                                </div>
                                <div className="subtitle">
                                    <h2 className="subtitulo">
                                        <LockIcon style={{ color: "#5452ff", fontSize: {xs: "1.6vw", sm: "3vw"} }}/> {FINAL_PRICE_TEXTS.MODAL.SECTIONS.INSURANCE}
                                    </h2>
                                    <p className="contenido">${insurance} {FINAL_PRICE_TEXTS.MODAL.COP}</p>
                                </div>
                                <div className="subtitle">
                                    <h2 className="subtitulo">
                                        <CardGiftcardIcon style={{ color: "#5452ff", fontSize: {xs: "1.6vw", sm: "3vw"} }} /> {FINAL_PRICE_TEXTS.MODAL.SECTIONS.HOME_DELIVERY}
                                    </h2>
                                    <p className="contenido-tachado">$62,000 {FINAL_PRICE_TEXTS.MODAL.COP}</p><span className="gratisText">{FINAL_PRICE_TEXTS.MODAL.FREE_TEXT}</span>
                                </div>
                            </>
                        }
                        buttonText={FINAL_PRICE_TEXTS.MODAL.BUTTON_TEXT}
                        onButtonClick={handleClose}
                        modalClass="recuadro" 
                        titleClass="tituloRecuadro"
                        contentClass="textoUsd" 
                        buttonClass="botonListo"
                        sx={{
                            button: {
                                backgroundColor: '#b3df53',
                                color: 'white',
                                boxShadow:"0 3px 6px rgba(0, 0, 0, 0.1)",
                                textTransform:"none",
                                padding: "1vw",
                                fontSize: {xs: '3vw', sm: '1.4vw'},
                                borderRadius: '2vw',
                                transition: 'background-color 0.3s, transform 0.3s ease',
                                fontFamily: "'Viga', sans-serif",
                                marginBottom: '1vw',
                                display: 'flex',
                                '&:hover': {
                                    backgroundColor: '#b3df53',
                                    transform: 'scale(1.05)',
                                },
                            },
                        }}
                    />
                </>
            )}
        </>
    );
}

export default FinalPrice;